exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ItemSrcControl[data-v-630ea274] {\n  display: grid;\n  grid-template-columns: 1fr 70px;\n}\n.ItemSrcControl_Url[data-v-630ea274] {\n    height: 14px;\n    width: 100%;\n}\n.ItemSrcControl_Button[data-v-630ea274] {\n    color: inherit;\n    text-align: center;\n    min-width: 20px;\n    min-height: 20px;\n    padding: 0 15px;\n    border: none;\n    background: none;\n    margin-right: 0;\n}\n", ""]);

// exports
